import { Address, beginCell, Cell, fromNano, OpenedContract, toNano, } from '@ton/core';
// import { compile, sleep, NetworkProvider, UIProvider, } from '@ton/blueprint';
import { Presale  } from '../wrappers/presale';
import { promptBool, promptAmount, promptAddress, displayContentCell,  promptUrl, } from '../wrappers/utils';
import { TonConnectUI } from '@tonconnect/ui-react';
let minterPRESALEContract: OpenedContract<Presale>;

const adminActions = [  'Change state', 'Withdrawal'];
const userActions  = ['Info', 'Quit','Buy','Claim', 'Mint'];

// const failedTransMessage = (ui: UIProvider) => {
//     ui.write("Failed to get indication of transaction completion from API!\nCheck result manually, or try again\n");
// };

// export const infoAction = async (provider: NetworkProvider, ui: UIProvider) => {
//     const jettonData = await minterPRESALEContract.getJettonData();
//     ui.write("Jetton info:\n\n");
//     ui.write(`Admin: ${jettonData.adminAddress}\n`);
//     ui.write(`Total supply: ${fromNano(jettonData.totalSupply)}\n`);
//     ui.write(`Mintable: ${jettonData.mintable}\n`);
   
//     const displayPRESALE = await ui.choose('Display PRESALE info?', ['Yes', 'No'], (c) => c);
//     if (displayPRESALE == 'Yes') {
//         const PRESALEData = await minterPRESALEContract.getPRESALEData();
//         ui.write("PRESALE info:\n\n");
//         ui.write(`State: ${PRESALEData.state}\n`);
//         ui.write(`Price: ${PRESALEData.price}\n`);
//         ui.write(`Cap: ${PRESALEData.cap}\n`);
//         ui.write(`Start date: ${fromNano(PRESALEData.start_date)}\n`);
//         ui.write(`End date: ${fromNano(PRESALEData.end_date)}\n`);
//     }
// };

// export const ClaimAction = async (provider: NetworkProvider, ui: UIProvider) => {
//     const sender = provider.sender();
   
    
//     // const lastSeqno = (await provider.api().getLastBlock()).last.seqno;
//     // const curState = (await provider.api().getAccountLite(lastSeqno, minterPRESALEContract.address)).account;

//     // if (curState.last === null)
//     //     throw ("Last transaction can't be null on deployed contract");

//     // const res = await minterPRESALEContract.sendClaim(sender);
//     // const gotTrans = await waitForTransaction(provider,
//     //     minterPRESALEContract.address,
//     //     curState.last.lt,
//     //     10);
//     // if (gotTrans) {
      
//     // }
//     // else {
//     //     failedTransMessage(ui);
//     // }

// }

export const buyAction = async (presaleContract: Presale, sender: string, tonConnection: TonConnectUI, amountToBuy: string, presaleContractAddress: Address) => {
    
    const res = await presaleContract.sendBuy(tonConnection, presaleContractAddress, toNano(amountToBuy), sender);
    return res;
}

export const claimAction =  async (presaleContract: Presale, sender: string, tonConnection: TonConnectUI,  presaleContractAddress: Address) => {
    
    const res = await presaleContract.sendClaim(tonConnection, presaleContractAddress, sender);
    return res;
}

// const withdrawalAction = async (provider: NetworkProvider, ui: UIProvider) => {
//     const sender = provider.sender();
//     let retry: boolean;

//     // do {
//     //     retry = false;
//     //     retry = !(await promptBool('Is it ok to withdraw TON from PRESALE on the admin wallet?(yes/no)', ['yes', 'no'], ui));
//     // } while (retry);

//     // const lastSeqno = (await provider.api().getLastBlock()).last.seqno;
//     // const curState = (await provider.api().getAccountLite(lastSeqno, minterPRESALEContract.address)).account;

//     // if (curState.last === null)
//     //     throw ("Last transaction can't be null on deployed contract");

//     // const contractBalanceBefore = BigInt((await provider.api().getAccountLite(lastSeqno, minterPRESALEContract.address)).account.balance.coins);

//     // const res = await minterPRESALEContract.sendWithdraw(sender);
//     // const gotTrans = await waitForTransaction(provider,
//     //     minterPRESALEContract.address,
//     //     curState.last.lt,
//     //     10);
//     // if (gotTrans) {
//     //     const lastSeqno = (await provider.api().getLastBlock()).last.seqno;
//     //     const contractBalanceAfter = BigInt((await provider.api().getAccountLite(lastSeqno, minterPRESALEContract.address)).account.balance.coins);

//     //     if (contractBalanceAfter < contractBalanceBefore) {
//     //         ui.write("Withdrawal successfull!\nYou have received:" + fromNano(contractBalanceBefore - contractBalanceAfter));
//     //     } else {
//     //         ui.write("Withdrawal failed!");
//     //     }
//     // } else {
//     //     failedTransMessage(ui);
//     // }
// }

// export async function run(provider: NetworkProvider) {
//     const ui = provider.ui();
//     const sender = provider.sender();
//     const hasSender = sender.address !== undefined;
//     const api = provider.api()
//     let done = false;
//     let retry: boolean;
//     let PRESALEAddress: Address;

//     // do {
//     //     retry = false;
//     //     PRESALEAddress = await promptAddress('Please enter PRESALE address:', ui);
//     //     const isContractDeployed = await provider.isContractDeployed(PRESALEAddress);
//     //     if (!isContractDeployed) {
//     //         retry = true;
//     //         ui.write("This contract is not active!\nPlease use another address, or deploy it first");
//     //     }
//     //     else {
//     //         const lastSeqno = (await api.getLastBlock()).last.seqno;
//     //         const contractState = (await api.getAccount(lastSeqno, PRESALEAddress)).account.state as {
//     //             data: string | null;
//     //             code: string | null;
//     //             type: "active";
//     //         };
//     //         if (!(Cell.fromBase64(contractState.code as string)).equals(minterPRESALECode)) {
//     //             ui.write("Contract code differs from the current contract version!\n");
//     //             const resp = await ui.choose("Use address anyway", ["Yes", "No"], (c) => c);
//     //             retry = resp == "No";
//     //         }
//     //     }
//     // } while (retry);

//     // minterPRESALEContract = provider.open(Presale.createFromAddress(PRESALEAddress));
//     // const isAdmin = hasSender ? (await minterPRESALEContract.getAdminAddress()).equals(sender.address) : true;
//     // let actionList: string[];
//     // if (isAdmin) {
//     //     actionList = [...adminActions, ...userActions];
//     //     ui.write("Current wallet is PRESALE admin!\n");
//     // }
//     // else {
//     //     actionList = userActions;
//     //     ui.write("Current wallet is not admin!\nAvaliable actions restricted\n");
//     // }

// }